import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ 'icon' ]
  static values = { text: String }

  initialize() {
    this.element.addEventListener('turbo:before-morph-element', (event) => {
      if (event.target === this.element) {
        event.preventDefault()
      }
    })
  }

  copy() {
    navigator.clipboard.writeText(this.textValue).then(
      this.iconTarget.classList.replace('fa-copy', 'fa-check')
    ).catch(
      this.iconTarget.classList.replace('fa-copy', 'fa-xmark')
    ).finally(
      setTimeout(() => {
        this.iconTarget.classList.replace('fa-check', 'fa-copy')
        this.iconTarget.classList.replace('fa-xmark', 'fa-copy')
      }, '3000')
    )
  }
}
